export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: '页面未找到',
    description: '您访问的页面不存在',
    goBack: '返回首页',
  },
  common: {
    loading: '加载中...',
    noData: '暂无数据',
    error: '操作失败，请重试',
    retry: '重试',
    authExpired: '登录已过期，请重新登录',
    requestFailed: '请求失败',
    networkError: '网络错误，请检查网络连接',
    skipToContent: '跳到主要内容',
  },
  nav: {
    dashboard: '控制台',
    visa: '签证',
    cost: '成本',
    timezone: '时区',
    tax: '税务',
    guide: '指南',
    login: '登录',
  },
  footer: {
    about: '关于',
    privacy: '隐私政策',
    terms: '服务条款',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: '你的数字游民生活，井井有条',
      subtitle: '一站式签证管理、生活成本比较、时区协调、税务合规和旅居指南平台',
      cta: '免费开始使用',
      learnMore: '了解更多',
    },
    features: {
      title: '核心功能',
      visa: { title: '签证追踪', desc: '追踪各国签证类型、有效期和续签提醒' },
      cost: { title: '成本比较', desc: '对比不同城市的住宿、饮食、交通等生活成本' },
      timezone: { title: '时区管理', desc: '多时区时钟和跨时区会议时间协调' },
      tax: { title: '税务助手', desc: '跨境税务规则查询和居住天数风险预警' },
      guide: { title: '旅居指南', desc: '全球数字游民目的地城市详细指南' },
    },
    stats: {
      countries: '覆盖国家',
      cities: '旅居城市',
      languages: '支持语言',
    },
  },
  login: {
    login: '登录',
    register: '注册',
    subtitle: '登录游民助手，管理您的旅居生活',
    registerSubtitle: '创建账户，开始您的数字游民之旅',
    email: '邮箱',
    emailPlaceholder: 'your@email.com',
    emailInvalid: '请输入有效的邮箱地址',
    username: '用户名',
    usernamePlaceholder: '输入用户名',
    password: '密码',
    passwordPlaceholder: '••••••••',
    passwordTooShort: '密码至少6位',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '再次输入密码',
    passwordMismatch: '两次密码不一致',
    loading: '登录中...',
    error: '登录失败，请重试',
    orContinueWith: '或通过以下方式继续',
    noAccount: '还没有账户？',
    hasAccount: '已有账户？',
  },
  dashboard: {
    welcome: '欢迎回来，{name}',
    subtitle: '您的旅居生活概览',
    stats: {
      activeVisas: '有效签证',
      daysUntilExpiry: '最近到期天数',
      citiesCompared: '已比较城市',
      timezones: '追踪时区',
    },
    expiryAlerts: '签证到期提醒',
    noAlerts: '暂无到期提醒',
    daysLeft: '{days}天后到期',
    worldClocks: '世界时钟',
    quickActions: '快捷操作',
    actions: {
      visa: '签证管理',
      cost: '成本比较',
      timezone: '时区管理',
      tax: '税务助手',
      guide: '旅居指南',
    },
    recentActivity: '最近活动',
    noActivity: '暂无最近活动',
  },
  visa: {
    title: '签证管理',
    subtitle: '追踪和管理您的签证信息',
    searchPlaceholder: '搜索国家名称...',
    allRegions: '所有地区',
    regions: {
      europe: '欧洲',
      asia: '亚洲',
      americas: '美洲',
      oceania: '大洋洲',
    },
    noCountries: '未找到符合条件的国家',
    requirements: '申请要求',
    documents: '所需文件',
    track: '追踪此签证',
    applyUrl: '申请链接',
    myTracked: '我追踪的签证',
  },
  cost: {
    title: '生活成本',
    subtitle: '比较不同城市的生活成本',
    selectCities: '选择城市',
    selectHint: '选择2-4个城市进行比较',
    compare: '开始比较',
    selectedCount: '已选择 {count} 个城市',
    comparison: '成本对比',
    category: '类别',
    nomadScore: '游民评分',
    budgetFinder: '预算查找',
    budgetPlaceholder: '输入月度预算',
    findCities: '查找城市',
    aiSuggestion: 'AI 智能推荐即将上线',
  },
  timezone: {
    title: '时区管理',
    subtitle: '管理多时区日程和会议',
    addTimezone: '添加时区',
    noTimezones: '点击上方按钮添加时区',
    meetingScheduler: '会议时间协调',
    meetingHint: '选择参与者的时区，查找最佳会议时间',
    findMeeting: '查找会议时间',
    finding: '正在查找...',
    bestTime: '最佳时间',
    workingOverlap: '工作时间重叠',
  },
  tax: {
    title: '税务助手',
    subtitle: '跨境税务计算与合规建议',
    rules: '税务规则',
    selectCountry: '选择国家',
    thresholdDays: '居住天数阈值',
    days: '天',
    taxRates: '税率',
    reportingRequirements: '申报要求',
    importantDates: '重要日期',
    residenceTracker: '居住天数记录',
    noResidenceDays: '暂无居住天数记录',
    riskIndicator: '税务风险指标',
    noRiskData: '暂无风险数据',
    countries: {
      portugal: '葡萄牙',
      thailand: '泰国',
      spain: '西班牙',
      germany: '德国',
      estonia: '爱沙尼亚',
      georgia: '格鲁吉亚',
      croatia: '克罗地亚',
      mexico: '墨西哥',
      colombia: '哥伦比亚',
      indonesia: '印度尼西亚',
      japan: '日本',
      southKorea: '韩国',
      unitedKingdom: '英国',
      unitedStates: '美国',
    },
  },
  guide: {
    title: '旅居指南',
    subtitle: '全球数字游民旅居目的地指南',
    allContinents: '全部',
    noCities: '未找到符合条件的城市',
    backToList: '返回列表',
    internetQuality: '网络质量',
    safetyRating: '安全评级',
    climate: '气候',
    communitySize: '社区规模',
    coworkingSpaces: '联合办公空间',
    noCoworking: '暂无联合办公空间信息',
    day: '天',
  },
  settings: {
    title: '设置',
    subtitle: '管理您的账户和应用偏好',
    profile: '个人资料',
    username: '用户名',
    email: '邮箱',
    saveProfile: '保存资料',
    saving: '保存中...',
    language: '语言',
    notifications: '通知',
    visaExpiryNotif: '签证到期提醒',
    taxReminderNotif: '税务提醒',
    appearance: '外观',
    light: '浅色',
    dark: '深色',
    baseTimezone: '基准时区',
    dangerZone: '危险区域',
    dangerDesc: '以下操作不可撤销，请谨慎操作',
    deleteAccount: '删除账户',
    confirmDelete: '确认删除账户',
    confirmDeleteDesc: '此操作将永久删除您的账户和所有数据，且不可恢复。',
    cancel: '取消',
    confirm: '确认删除',
  },
  about: {
    title: '关于',
    subtitle: '游民助手 NomadMate',
    version: '版本',
    versionNumber: '1.0.0',
    description: 'NomadMate 是一款专为数字游民设计的生活助手应用，提供签证管理、生活成本比较、时区管理、税务计算和旅居指南等功能，帮助您轻松管理全球旅居生活。',
    openSource: '开源致谢',
    openSourceDesc: '本项目基于以下优秀的开源项目构建',
    contact: '联系我们',
    support: '技术支持',
    feedback: '意见反馈',
    privacyPolicy: '隐私政策',
    terms: '服务条款',
  },
}
